import { Component, type ReactNode } from 'react';

export class ErrorBoundary extends Component<{ children: ReactNode }, { hasError: boolean; message: string }> {
  state = { hasError: false, message: '' };
  static getDerivedStateFromError(error: Error) { return { hasError: true, message: error.message }; }
  render() {
    if (this.state.hasError) return <div className="fatal-error"><h1>Le module n’a pas pu être chargé.</h1><p>{this.state.message || 'Erreur inattendue.'}</p><button onClick={() => window.location.assign('/')}>Retour au Bureau ovale</button></div>;
    return this.props.children;
  }
}
